import { render, staticRenderFns } from "./CreateFacebookStories.vue?vue&type=template&id=67e88768&scoped=true&"
import script from "./CreateFacebookStories.vue?vue&type=script&lang=js&"
export * from "./CreateFacebookStories.vue?vue&type=script&lang=js&"
import style0 from "./CreateFacebookStories.vue?vue&type=style&index=0&id=67e88768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e88768",
  null
  
)

export default component.exports